import React from 'react';
import './../App.css';

const Footer = () => {
  return (
    <footer class="footer">
    <p>&copy; 2023-{new Date().getFullYear()}  Yellow Ray Consulting Group Inc. All rights reserved.</p>
    <ul>
      
        <a href="https://www.linkedin.com/company/yellowray-consulting-group/"><i class="fab fa-linkedin fa-2x"></i></a>
      
    </ul>
  </footer>
  );
};

export default Footer;